import '../scss/main.scss';

import CarouselSlider from './carousel';

window.addEventListener('DOMContentLoaded', function(){
	let sliderContainers = document.querySelectorAll('.block-type-carousel');

	if (sliderContainers.length < 1) {
		return;
	}

	sliderContainers = [].slice.call(sliderContainers);

	sliderContainers.forEach( container => {
		new CarouselSlider(container, {autoDelay : 5000}, container.querySelector('.slides'), container.querySelector('.slide-pagedots-container'));
	});
});